import Observer, {IObserver, IObserverOptionsCommon} from '~/utils/observer'

export interface IFormulaObserverOptions<M> extends IObserverOptionsCommon<M> {
  formula: string
}

export interface IFormulaObserver<M> extends IObserver<M> {
  formula: string
  type: 'formula'
}

export default class FormulaObserver<M> extends Observer<M, IFormulaObserverOptions<M>> implements IFormulaObserver<M> {
  readonly type: 'formula' = 'formula'

  constructor(protected options: IFormulaObserverOptions<M>) {
    super(options)
  }

  get formula(): string {
    return this.call("formula")
  }
}